import { InputWithOptionsDriver } from '../InputWithOptions/InputWithOptions.driver';

export interface MultiSelectCheckboxDriver extends Omit<
  InputWithOptionsDriver,
  'driver'
> {
  driver: {
    getNumOfLabels: () => number;
    getLabels: (delimiter?: string) => string[];
    getLabelAt: (index: number, delimiter?: string) => string;
  } & Pick<InputWithOptionsDriver, 'driver'>;
}
